module.exports = __webpack_public_path__ + "static/media/Pitts-photo.2db7f9ba.PNG";